<template>
  <div id="municipalities-insee-list">
    <div
      id="municipalitiesListInputHelpBlock"
      class="form-text above"
    >
      {{ $t('jurisdictions.municipalities.inseeList.help') }}
    </div>
    <div class="mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <input
          id="municipalitiesListInput"
          v-model="inseeList"
          type="text"
          :class="{ 'is-invalid': !isListValid }"
          class="form-control"
          :placeholder="$t('jurisdictions.municipalities.inseeList.placeholder')"
        >
        <i
          v-if="!isListCopied"
          class="bi bi-clipboard"
          @click="copyToClipboard"
        />
        <i
          v-else
          class="bi bi-clipboard-check"
          @click="copyToClipboard"
        />
      </div>
      <div class="d-flex justify-content-end mt-1">
        <button
          type="button"
          :class="{
            disabled: !inseeList || !isListValid
          }"
          class="btn btn-primary btn-sm"
          @click="selectINSEEList"
        >
          {{ $t('words.recalculate') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MunicipalitiesINSEEList',

  props: {
    initValues: {
      type: Array,
      default: () => { return []; }
    }
  },

  data() {
    return {
      inseeList: null,
      isListValid: true,
      isListCopied: false
    };
  },

  computed: {
    ...mapState('municipalities', [
      'municipalitiesList',
      'selectedMunicipalities'
    ]),
  },

  watch: {
    initValues: {
      deep: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.inseeList = newValue.join(',');
        }
      }
    },
    inseeList: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          this.isListValid = true;
        } else {
          this.inseeList = newValue.replace(/\s/g, '');
          const regex = new RegExp(/^(\d{4,5})(,\d{4,5})*$/g);
          this.isListValid = regex.test(this.inseeList);
        }
      }
    }
  },

  methods: {
    ...mapActions('municipalities', [
      'DESELECT_ALL_MUNICIPALITIES',
      'SELECT_MUNICIPALITY'
    ]),

    async selectINSEEList() {
      try {
        this.$emit('loading', true);
        await this.DESELECT_ALL_MUNICIPALITIES();
        const inseeArray = this.inseeList.split(',');
        for (const insee of inseeArray) {
          const municipality = this.municipalitiesList.find(el => el.insee === insee);
          if (municipality) {
            await this.SELECT_MUNICIPALITY(municipality);
          } else {
            const index = inseeArray.findIndex(el => el === insee);
            if (index !== -1) {
              inseeArray.splice(index, 1);
            }
          }
        }
        this.inseeList = inseeArray.join(',');
        this.$emit('loading', false);
      } catch (err) {
        console.error(err);
        this.$emit('loading', false);
      }
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.inseeList);
      this.isListCopied = true;
      setTimeout(() => {
        this.isListCopied = false;
      }, 1000);
    },
  }
};
</script>

<style lang="less" scoped>
#municipalitiesListInput {
  text-overflow: ellipsis;
}
.bi-clipboard, .bi-clipboard-check {
  cursor: pointer;
  margin-left: 0.5rem;
  font-size: 1.25rem;
}
</style>